<template>
  <div>

    <hr>

    <!-- Company Workspace, Job Role, Company Size -->
    <validation-observer
      ref="companyObserver"
      v-slot="{ invalid }"
    >
      <!-- Company Workspace -->
      <b-form-group
        label="Name your first Workspace"
        label-for="workspace"
      >
        <validation-provider
          #default="{ errors }"
          name="Workspace"
          rules="required"
        >
          <b-form-input
            id="workspace"
            v-model="newUser.workspace"
            :state="errors.length > 0 ? false : null"
            name="register-workspace"
            placeholder="The name of your company or your name"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Your Job Role -->
      <b-form-group
        label="Your Job Role"
        label-for="jobTitle"
      >
        <validation-provider
          #default="{ errors }"
          name="Job Role"
        >
          <b-form-input
            id="jobTitle"
            v-model="newUser.jobTitle"
            :state="errors.length > 0 ? false : null"
            name="register-jobTitle"
            placeholder="Your job role"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Company Size -->
      <b-form-group
        label="Company Size"
        label-for="companySize"
      >
        <validation-provider
          #default="{ errors }"
          name="Company Size"
          rules="required"
        >
          <v-select
            id="companySize"
            v-model="newUser.companySize"
            :options="companySizeOptions"
            :state="errors.length > 0 ? false : null"
            placeholder="Select your company size"
            label="text"
            :reduce="(option) => option.value"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-button
        variant="primary"
        block
        class="mt-2"
        :disabled="invalid"
        @click="nextTab"
      >
        Next
      </b-button>

      <b-button
        variant="outline-primary"
        block
        @click="$emit('prevTab')"
      >
        Previous
      </b-button>
    </validation-observer>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BButton } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    newUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      workspace: '',
      jobTitle: '',
      companySize: '',
      companySizeOptions: [
        { text: '1-10', value: '1-10' },
        { text: '11-50', value: '11-50' },
        { text: '51-100', value: '51-100' },
        { text: '101-500', value: '101-500' },
        { text: '501-1000', value: '501-1000' },
        { text: '1000+', value: '1000+' },
      ],
      required,
      email,
    }
  },
  methods: {
    async  nextTab() {
      const isValid = await this.$refs.companyObserver.validate()
      if (!isValid) {
        return
      }
      this.$emit('nextTab')
    },
    prevTab() {
      this.$emit('prevTab')
    },
  },
}
</script>

<style></style>
